// extracted by mini-css-extract-plugin
export default {"account-creation":"AccountCreation_account-creation__p53j2"};